import { IScore } from "../../../../../../common/types";

export const getRhyt = (score: IScore) => {
    let tied: boolean[][] = [];
    let isTied = false;
    let rhyt: number[][] = [];
    score.bars.forEach((bar, index) => {
        tied.push([]);
        rhyt.push([]);
        if (bar === null) return;
        bar.notes.forEach((note, noteIndex) => {
            rhyt[rhyt.length - 1].push((4 / note.l) * (note.d ? 1.5 : 1) * (note.t ? (2/3) : 1) * (note.r ? -1 : 1));
            if (isTied) {
                isTied = false;
            }
            if (note.tie) {
                isTied = true;
                tied[index][noteIndex] = true;
            }
        });
    });
    if (rhyt[rhyt.length - 1].length === 0) rhyt.pop();

    return { tied, rhyt };
};
